import { BrowserRouter as Router } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './tailwind.css';
import { AuthProvider } from './contexts/AuthContext';
import { MediaProvider } from '@/contexts/MediaContext';
import { CompanyProvider } from '@/contexts/CompanyContext';
import RoutesConfig from './routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/th';
import { ConfigProvider } from 'antd';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(relativeTime);
dayjs.locale('th'); // use locale

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

// Create a new QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // cacheTime is not a valid option here; remove or replace with supported options if needed
    },
  },
});
console.log(
  'REACT_APP_PUBLIC_BASE_API_URL:',
  process.env.REACT_APP_PUBLIC_BASE_API_URL,
);
root.render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <MediaProvider>
        <CompanyProvider>
          <Router>
            <ConfigProvider
              theme={{
                components: {
                  Menu: {
                    darkItemBg: '#1e7f5b',
                  },
                  Tabs: {
                    itemHoverColor: '#c6251b',
                    itemSelectedColor: '#c6251b',
                    inkBarColor: '#c6251b',
                    itemActiveColor: '#c6251b',
                    fontSize: 16,
                  },
                  Button: {
                    colorPrimaryHover: '#831812',
                    colorPrimary: '#c6251b',
                    colorPrimaryActive: '#c6251b', // Button color when active
                    colorBgTextHover: '',
                    colorBgTextActive: '',
                    // colorTextHofer: '#c6251b',
                  },
                  Table: {
                    // headerBg: '#fbe5e4',
                    // borderColor: '#d8d8d8',
                    // rowHoverBg: '#fbeaea',
                  },
                  DatePicker: { colorPrimary: '#c6251b' },
                  Breadcrumb: {
                    colorTextBase: '#c6251b',
                    colorTextLabel: '#c6251b',
                  },
                  Segmented: {
                    itemSelectedBg: '#c6251b',
                    itemSelectedColor: 'white',
                    itemColor: 'black',
                    itemHoverBg: '#cdd7f7',
                    trackPadding: 4,
                  },
                  Steps: {
                    descriptionMaxWidth: 300,
                  },
                  Layout: {
                    headerBg: '#1e7f5b',
                  },
                  Radio: {
                    buttonSolidCheckedHoverBg: '#c6251b',
                    buttonSolidCheckedBg: '#c6251b',
                    colorPrimaryBorder: '#c6251b',
                  },
                },
              }}
            >
              <RoutesConfig />
            </ConfigProvider>
          </Router>
        </CompanyProvider>
      </MediaProvider>
    </AuthProvider>
  </QueryClientProvider>,
);

reportWebVitals();
